module.exports = function(app) {
	'use strict'
	app.directive('searchPostDir',searchPostDir);
	searchPostDir.$inject=['elasticSearch','$http','$timeout','keyPress','offlineError'];
	function searchPostDir(elasticSearch,$http,$timeout,keyPress, offlineError) {
		return {
			restrict: 'E',
      scope:{
          parentObj:"=",
          noAddBtn:'=',
          removeSelected:'=',
          searchPostObj:'='
      },
      replace:true,
			template: require('./partial/searchPost.html'),
			link: function(scope, ele, $attrs, ctrl) {
        scope.hiddenResult = true;
        scope.hasResult = true;
        scope.searchPage = 0;
        scope.postResult = [];
        scope.$watch(function(){
          return scope.searchPostObj
        }, function(newValue, oldValue){
          if (oldValue !==newValue && newValue) {
            onloadPopulateSearch()
          }
        },true);
        function onloadPopulateSearch() {
          if(scope.searchPostObj) {
            scope.searchPostsData = '('+scope.searchPostObj._id+') - ' +  scope.searchPostObj.title;
            if(scope.removeSelected) {
              scope.disableInput = true;
            }
            if(scope.noAddBtn) {
              scope.parentObj.searchPostObj = {
                'id': scope.searchPostObj._id,
                'title' : scope.searchPostObj.title,
                'url' : scope.searchPostObj.url
              };
            }
          } 
        }
        if(scope.searchPostObj) {
          onloadPopulateSearch()
        }
        if(scope.noAddBtn) {
          scope.parentObj.searchPostReset = function() {
            searchPostReset()
          };
        }
        function searchPostReset() {
          scope.searchPostsData = null;
          scope.searchObj = null;
          if(scope.noAddBtn) {
            scope.parentObj.searchPostObj = null
          }
          if(scope.removeSelected) {
            scope.disableInput = false;
          }
        }
        scope.addSearchPost = function(searchObj) {
            if(searchObj && scope.searchPostsData) {
              scope.parentObj.addPostFromSearch(searchObj);
            }
            scope.searchPostsData = null;
            scope.searchObj = null;
        }
        scope.chooseSearchData = function(post) {
            scope.searchPostsData = '('+post._id+') - ' +  post._source.post_title;
            scope.hiddenResult = true;
            scope.searchObj = {
              'id': post._id,
              'title' : post._source.post_title,
              'uri' : post._source.url.substr(23),
              'url': post._source.url,
              'image': post._source.image
            };
            if(scope.noAddBtn) {
              scope.parentObj.searchPostObj = {
                'id': post._id,
                'title' : post._source.post_title,
                'url' : post._source.url
              };
            }
            if(scope.removeSelected) {
              scope.disableInput = true;
            }
          };
          scope.enableInput = function() {
            searchPostReset()
          }
          function mouseDown(e) {
            if(angular.element(document.getElementsByClassName("autocomplete-result"))) {
              var container = angular.element(document.getElementsByClassName("autocomplete-result"));
              var serch_input = angular.element(document.getElementsByClassName("search-autocomplete"));
              if (!container.is(e.target) // if the target of the click isn't the container...
                && container.has(e.target).length === 0 && !scope.hiddenResult && !serch_input.is(e.target) && serch_input.has(e.target).length===0) // ... nor a descendant of the container
              {
                scope.$apply(function () {
                  scope.hiddenResult = true;
                  scope.postResult = [];
                  scope.searchPage = 0;
                });
              }
            }
          }
          angular.element(document).on('mousedown', mouseDown);
          scope.searchPress = function(evt,star) {
            keyPress(evt,star);
          }
          scope.readMore = function() {
            scope.searchPage +=10;
            $timeout(function() {
              scope.search('loadMore');
            },0)
          }
          scope.search = function(loadMore) { 
            var size=10;
            scope.loadMore = false;
            if(loadMore!='loadMore') {
              scope.searchPage = 0;
              scope.postResult = [];
            }
            // scope.hiddenResult = true;
            if(scope.searchPostsData) { 
              if(scope.searchPostsData.length >1) {
                var url = elasticSearch.getUrl(scope.searchPostsData);
                url = url + '&from='+ scope.searchPage +'&size='+ size;
                
                $http({
                  method: 'GET',
                  url: url
                }).then(function successCallback(response) {
                    if(loadMore=='loadMore') {
                      scope.postResult = scope.postResult.concat(response.data.hits.hits);
                    } else {
                      scope.postResult = response.data.hits.hits;
                    }
                    if(scope.postResult.length > 0) {
                      scope.hasResult = true;
                      scope.loadMore = true;
                    } else {
                      scope.hasResult = false;
                    }
                    scope.hiddenResult = false;
                    if(response.data.hits.total >scope.postResult.length) {
                      scope.loadMore = true;
                    } else {
                      scope.loadMore = false;
                    }
                    // this callback will be called asynchronously
                    // when the response is available
                }, function errorCallback(response) {
                  if(!window.navigator.onLine) {
                    offlineError()
                    return
                  }
                    // called asynchronously if an error occurs
                    // or server returns response with an error status.
                });
              } else {
                scope.hiddenResult = true;
              } 
            } else {
              scope.hiddenResult = true;
              searchPostReset()
            }
        }
        scope.$on('$destroy',function(){
          angular.element(document).off('mousedown',mouseDown);
        })
			}
		}
	}
}


//////////////////
// WEBPACK FOOTER
// ./public/development/assets/app/js/directive/searchPost/searchPostDirective.js
// module id = 449
// module chunks = 0